import { render } from "./indexUserScore.vue?vue&type=template&id=5ae05f4a&scoped=true"
import script from "./indexUserScore.vue?vue&type=script&lang=js"
export * from "./indexUserScore.vue?vue&type=script&lang=js"

import "./indexUserScore.vue?vue&type=style&index=0&id=5ae05f4a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae05f4a"]])

export default __exports__